<template>
  <div>
    <!--<google-sign-in/>-->
    <v-textarea
      v-model="functionText"
      label="Paste JavaScript Function Here"
      auto-grow
    ></v-textarea>

    <v-progress-circular
      v-if="isLoading"
      indeterminate
      color="primary"
      size="24"
      class="mr-2"
    />

    <!-- Multi-Select Dropdown -->

    <v-btn @click="postFunction" class="mb-4">Execute</v-btn>
    <v-select
      v-model="arrays_selected"
      :items="arrays_to_fetch"
      label="Select Data Arrays"
      multiple
      chips
      clearable
      class="mt-4 mb-4"
    ></v-select>
    <v-expansion-panels>
      <v-expansion-panel
        v-for="(records, tableName) in tabularData"
        :key="tableName"
      >
        <v-expansion-panel-title>{{ tableName }}</v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-table>
            <thead>
              <tr>
                <th v-for="header in getHeaders(records)" :key="header">
                  {{ header }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in records" :key="index">
                <td v-for="header in getHeaders(records)" :key="header">
                  {{ row[header] }}
                </td>
              </tr>
            </tbody>
          </v-table>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-expansion-panels>
      <v-expansion-panel v-if="executionResults.length > 0">
        <v-expansion-panel-title>JS Execution Results</v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-table>
            <thead>
              <tr>
                <th
                  v-for="header in getHeaders(executionResults)"
                  :key="header"
                >
                  {{ header }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in executionResults" :key="index">
                <td
                  v-for="header in getHeaders(executionResults)"
                  :key="header"
                >
                  {{ row[header] }}
                </td>
              </tr>
            </tbody>
          </v-table>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card class="mt-4">
      <v-btn @click="getData" :disabled="loading">
        <v-progress-circular
          v-if="loading"
          indeterminate
          size="24"
          class="mr-2"
        />
        Fetch
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { gql } from "graphql-tag";

export default {
  computed: {
    ...mapState(["loggedInGoogle", "userGoogle", "country"]),
  },
  async mounted() {
    await this.getData();
  },
  data() {
    return {
      isLoading: false,
      tabularData: {},
      executionResults: [],
      functionText: "",
      loading: false,
      arrays_selected: [],
      arrays_to_fetch: [
        "ohlc_candles_equity_index_spot_1_minute",
        "ohlc_candles_equity_index_spot_1_hour",
        "equity_index_options_live",
        "commodity_options_live",
        "equity_index_futures_live",
        "commodity_futures_live",
        "equity_index_spot_live",
        "equity_stock_spot_live",
        "equity_index_options_ohlc_1_minute_today",
        "commodity_options_ohlc_1_minute_today",
        "equity_index_futures_ohlc_1_minute_today",
        "commodity_futures_ohlc_1_minute_today",
        "equity_index_spot_ohlc_1_minute_today",
        "equity_stock_spot_ohlc_1_minute_today",
        "market_index_wise_companies",
        "stock_price_daily_historical",
        "market_index_price_daily",
        "stock_price_volume_daily_moving_averages",
        "market_index_price_volume_daily_moving_averages",
        "company_profile",
        "shareholding_pattern",
        "income_statement",
        "cash_flow_statement",
        "balance_sheet_statement",
        "balance_sheet_statement_growth",
        "income_statement_growth",
        "cash_flow_statement_growth",
        "key_metrics",
        "income_statement_growth_quarterly",
        "income_statement_quarterly",
        "discounted_cash_flow",
        "levered_discounted_cash_flow",
        "key_metrics_ttm",
        "custom_discounted_cash_flow",
        "custom_levered_discounted_cash_flow",
        "enterprise_values",
        "owner_earnings",
        "financial_scores",
        "financial_growth",
        "peers",
      ],
    };
  },
  methods: {
    async getData() {
      this.loading = true;
      try {
        if (this.arrays_selected.length > 0) {
          const csv = this.arrays_selected.join(",");
          const resp = await fetch(`/api/chat/arrayview?array_name=${csv}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });
          this.tabularData = await resp.json();
          console.log("this.tabularData", this.tabularData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loading = false;
      }
    },
    getHeaders(records) {
      return records.length > 0 ? Object.keys(records[0]) : [];
    },
    async postToGraphQL(payload) {
      try {
        const resp = await this.$apollo.query({
          query: gql`
            ${payload.query}
          `,
          variables: payload.variables,
          fetchPolicy: "no-cache",
        });
        return resp;
      } catch (e) {
        console.error(e);
      }
    },
    async postFunction() {
      try {
        const resp = await fetch(`/api/chat/js_exec`, {
          method: "POST",
          body: JSON.stringify({ functionText: this.functionText, country: this.country }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const jsExecResp = await resp.json();
        console.log("jsExecResp", jsExecResp);
        this.tabularData = jsExecResp.jsExecResponse.result.result;
      } catch (e) {
        console.error(e);
      }
    },
    async executeFunction() {
      try {
        this.isLoading = true;
        const sanitizedFunctionText = this.functionText; //this.functionText.replace(/^const analysis = async function/, 'async function analysis');
        console.log(this.tabularData);
        const asyncFunc = new Function(
          "pre_populated_arrays",
          "postToGraphQL",
          `return (${sanitizedFunctionText})(pre_populated_arrays);`
        );
        this.executionResults = await asyncFunc(
          this.tabularData,
          this.postToGraphQL
        );
        console.log(this.executionResults);
        this.isLoading = false;
      } catch (error) {
        console.error("Error executing function:", error);
        this.executionResults = [];
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
th,
td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
</style>
